import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'dhwani-material-library';
import { TempModuleService } from '../../form-translate/services/temp-module.service';

export interface publishFormData {
    questions: any[],
    copiedFormId: any,
    formId: string | number,
    form?: any,
    duplicateCheckQuestions: string[],
    keyInfoOrders: string[],
    title? : string,
    reportedDateOrder,
    formType?: string,
    publishValidations?:any
}

@Component({
    selector: 'app-view-sequence-popup',
    templateUrl: './view-sequence-popup.component.html',
    styleUrls: ['./view-sequence-popup.component.css'],
    providers:[TempModuleService]
})
export class ViewSequencePopupComponent implements OnInit {

    public questions: any = [];
    public filteredQuestions: any = [];
    public viewSequenceForm: FormGroup;
    selectedQuestions: any[] = [];
    identifierQuestions: any[] = [];
    selectedQuestionIds: any[] = [];
    identifierQuestionsIds: any[] = [];
    submitTitle: string = 'Publish Form';
    questionsinput14: any =[];
    orderId: any;
    reportedDateOrder: any;
    isAllocator = ['name', 'mobile', 'languageCode', 'partnerName', 'baseGeography', 'formId', 'password']
    allocatorKey: any = [];
    nonByPassQuestion:any = []
    allQuestionList: any=[];
    constructor(private formBuilder: FormBuilder,
                private surveryBuilderService: TempModuleService,
                public dialogRef: MatDialogRef<ViewSequencePopupComponent>,
                @Inject(MAT_DIALOG_DATA) public data: publishFormData,private snackBar: MatSnackBar,) {
        this.createSurveyForm();

    }
    formType: string = '';
    createSurveyForm() {
        this.viewSequenceForm = this.formBuilder.group({
            question: [''],
            duplicateQuestions: [],
            dashboardIndicators: [false],
            vdpIndicators: [false],
            copyIndicators: [false],
            copyVdp: [false],
        });
    }

    ngOnInit() {
        this.getIndicatorStatus();
        this.updateQuestionsIfAlreadyFilled();
        this.submitTitle = this.data && this.data.title ? this.data.title : this.submitTitle;
        this.allQuestionList = this.data.questions
        this.questions = this.data.questions.filter(q => !q.order.toString().includes('.'));
        this.filteredQuestions = this.data.questions.filter(q => Number.isInteger(q.order));
        this.questions = this.questions.filter(q => q['input_type'] != 10);
        this.questionsinput14 = this.questions.filter(q => q['input_type'] == 14);
        console.log(this.questionsinput14)
        this.reportedDateOrder = this.data.reportedDateOrder && this.data.reportedDateOrder.toString()
        console.log(this.reportedDateOrder, this.data)
        if(this.data.hasOwnProperty('formType'))
        this.formType = this.data.formType;
        this.nonByPassQuestion = this.data['nonBypassableOrders'] && this.data['nonBypassableOrders'].length?this.data['nonBypassableOrders']:[]
        if(this.data.hasOwnProperty('publishValidations'))
        for(let key in this.data.publishValidations){
            this.allocatorKey.push(key)
        }

        console.log("formType", this.allocatorKey, this.formType, this.allocatorKey.includes(this.formType))
    }

    onNoClick() {
        this.dialogRef.close();
    }

    updateQuestionsIfAlreadyFilled() {
        let keyQuestions: string[] = this.data.keyInfoOrders;
        let duplicateCheckQuestions = this.data.duplicateCheckQuestions;
        if (keyQuestions&&keyQuestions.length > 0) {
            keyQuestions.forEach((question, index) => {
                this.selectedQuestions.push({ order: question, viewSequence: this.selectedQuestions.length + 1 });
                this.selectedQuestionIds[this.selectedQuestions.length] = question;
            });
        }
        if (duplicateCheckQuestions&&duplicateCheckQuestions.length > 0) {
            duplicateCheckQuestions.forEach((question, index) => {
                this.identifierQuestions.push({
                    order: question,
                    viewSequence: this.identifierQuestions.length + 1,
                });
                this.identifierQuestionsIds[this.identifierQuestions.length] = question;
            });
        }
    }

    checkAllocatorValidator(allocatorKey){
        console.log("chackValid", allocatorKey, this.formType, this.allocatorKey)
        let isAllocatorLength = 0;
        let alreadyShortKey = [];
        this.isAllocator = []
        for(let key in this.data.publishValidations[allocatorKey]){
        this.isAllocator.push(key.toLowerCase())
        this.data.questions.forEach(ques => {
            if (this.data.publishValidations[allocatorKey][key].includes(ques.shortKey.toLowerCase())){
                isAllocatorLength = isAllocatorLength + 1;
                alreadyShortKey.push(key.toLowerCase())
            }
        })
    }
       let remianingShortKeys = this.isAllocator.filter(item => !alreadyShortKey.includes(item))
        return remianingShortKeys
    }

    openSnackBar(data: string[], duration) {
        this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
    }
    
    closePopup() {
        console.log(this.reportedDateOrder, this.data)
        let isValid = true;
        let remainingShortkeys = [];
        if(this.formType != '' && this.allocatorKey.includes(this.formType)){
        remainingShortkeys = this.checkAllocatorValidator(this.formType);
        isValid = remainingShortkeys.length ? false: true

        console.log("valid", isValid)
        if(!isValid){
            this.openSnackBar([`${remainingShortkeys.join()} Short Keys are missing`], 4000)
            return true
        }
    }
        this.dialogRef.close({
            questions: this.selectedQuestions,
            duplicateQuestions: this.identifierQuestions,
            dashboardIndicators: this.viewSequenceForm.value.copyIndicators,
            vdpIndicators: this.viewSequenceForm.value.copyVdp,
            reportedDateOrder :this.reportedDateOrder,
            nonBypassableOrders:this.nonByPassQuestion
        });
    }

    filterQuestionArray(event: MatSelectChange, question, i) {
        if (event.value >= 0) {
            this.selectedQuestions[i] = { order: event.value, viewSequence: i + 1 };
            this.selectedQuestionIds[i] = event.value;
        } else {
            this.selectedQuestions.splice(i, 1);
            this.selectedQuestionIds.splice(i, 1);
            /*  for (let j = 0; j < this.selectedQuestions.length; j++) {
                  this.selectedQuestions[i].viewSequence = i + 1;
              }*/
        }

    }

    filterIdentifierQuestionArray(event: MatSelectChange, question, i) {
        if (event.value >= 0) {
            this.identifierQuestions[i] = { order: event.value, viewSequence: i + 1 };
            this.identifierQuestionsIds[i] = event.value;
        } else {
            this.identifierQuestions.splice(i, 1);
            this.identifierQuestionsIds.splice(i, 1);
          /*  for (let j = 0; j < this.identifierQuestions.length; j++) {
                this.identifierQuestions[i].viewSequence = i + 1;
            }*/
        }
    }

    getIndicatorStatus() {
        if (this.data.copiedFormId) {
            this.surveryBuilderService.getIndicatorStatus(this.data.copiedFormId).then((response: any) => {
                if (response.success) {
                    this.viewSequenceForm.patchValue({
                        vdpIndicators: response.data.vdpIndicators,
                        dashboardIndicators: response.data.dashboardIndicators,
                    });
                }
            });
        }
    }

    addNewQuestion() {
        this.selectedQuestionIds[this.selectedQuestions.length] = this.viewSequenceForm.value.question;
        this.selectedQuestions.push({
            order: this.viewSequenceForm.value.question,
            viewSequence: this.selectedQuestions.length + 1,
        });
        this.viewSequenceForm.controls['question'].reset();
    }
    addInputQues(val){
        console.log(val)
        if(val < 0){
        this.reportedDateOrder = ''
        }
        else{
        this.reportedDateOrder = val
        }

    }

    addNewIdentifierQuestion() {
        this.identifierQuestionsIds[this.identifierQuestions.length] = this.viewSequenceForm.value.duplicateQuestions;
        this.identifierQuestions.push({
            order: this.viewSequenceForm.value.duplicateQuestions,
            viewSequence: this.identifierQuestions.length + 1,
        });
        this.viewSequenceForm.controls['duplicateQuestions'].reset();
    }
    nonBypassFunc(val){
        console.log(">>>>>>",val)
    }
}
